import { AlarmIcon } from './AlarmIcon';

/**
 * author: Google
 * id 9A1AAF33-6F36-4987-9E8C-798E34D919A9
 * name alarm
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alarm.svg
 * tags
 * - Date / Time 
 */
export const AlarmClockIcon = AlarmIcon;
export default AlarmClockIcon